import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';

import type { Attachment } from '@core/attachments-types';
import { TranslatePipe } from '@core/i18n-legacy';
// eslint-disable-next-line boundaries/element-types
import { PdfViewerComponent } from '@core/pdf-viewer-smart-ui'; // --FIXME
import { DateComponent } from '@core/time-ui';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogData,
  HeadingComponent,
  IconComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

export type AttachmentPreviewDialogData = {
  attachment: Attachment;
  translations: {
    closeDialogTooltip: string;
    downloadFile: string;
  };
  header?: string;
  newDownloadedFileName?: string;
};

@Component({
  selector: 'rt-attachment-preview',
  templateUrl: './attachment-preview-dialog.component.html',
  styleUrls: ['./attachment-preview-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    DateComponent,
    DialogBodyComponent,
    HeadingComponent,
    IconComponent,
    PdfViewerComponent,
    TranslatePipe,
    TruncateComponent,
  ],
})
export class AttachmentPreviewDialogComponent {
  @Input() public attachment: Attachment;
  public isPdf: boolean;
  public isImage: boolean;
  public pdfUrl: string | null;
  public newDownloadedFileName?: string;
  public header?: string;
  public translations: AttachmentPreviewDialogData['translations'];

  constructor(
    @Optional()
    @Inject(DialogData)
    data: AttachmentPreviewDialogData,
  ) {
    if (data && data.attachment) {
      this.attachment = data.attachment;
      this.translations = data.translations;
      this.header = data.header;
      this.isPdf = !!data.attachment.pdfUrl;
      this.isImage = !!data.attachment.imageUrl;
      this.newDownloadedFileName = data.newDownloadedFileName;
      this.pdfUrl = this.isPdf ? encodeURIComponent(data.attachment.pdfUrl!) : null;
    }
  }
}
